import {
  AdminPage,
  ErrorPage,
  FilesConfirmationPage,
  FilesSelectorPage,
} from "@/pages";
import { createBrowserRouter, Navigate, Outlet } from "react-router";
import OverviewPage from "./pages/Overview/OverviewPage";
import CommentsPage from "./pages/Comments/CommentsPage";
import { GlobalHeader } from "./components/GlobalHeader/GlobalHeader";
import { SectionIndicator } from "./components/SectionIndicator/SectionIndicator";
import MetadataFlowPage from "./pages/MetadataFlow/MetadataFlow";
import MandatoryMetadata from "./components/MetadataFields/MandatoryMetadata";
import OptionalMetadata from "./components/MetadataFields/OptionalMetadata";
import { SelectUploadTypePage } from "./pages/SelectUploadType/SelectUploadTypePage";
import { UnderReviewPage } from "./pages/UnderReviewPage";
import MandatoryVideoMetadata from "./components/MetadataFields/MandatoryVideoMetadata";
import MandatoryDocumentMetadata from "./components/MetadataFields/MandatoryDocumentMetadata";
import { RequireAdmin } from "./components/RequireAdmin";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <GlobalHeader />
        <main className="mx-auto max-w-[1280px]">
          <SectionIndicator />
          <Outlet />
        </main>
      </>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <SelectUploadTypePage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/overview",
        element: <OverviewPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/uploads",
        element: <FilesSelectorPage />,
        errorElement: <ErrorPage />,
      },
      {
        path: "/uploads/:uploadId",
        element: <Outlet />,
        errorElement: <ErrorPage />,
        children: [
          {
            path: "",
            element: <MetadataFlowPage />,
            children: [
              {
                index: true,
                element: <Navigate to="mandatory-metadata" replace />,
              },
              {
                path: "mandatory-metadata",
                element: <MandatoryMetadata />,
                errorElement: <ErrorPage />,
              },
              {
                path: "optional-metadata",
                element: <OptionalMetadata />,
                errorElement: <ErrorPage />,
              },
            ],
          },
          {
            path: "confirm-files",
            element: <FilesConfirmationPage />,
            errorElement: <ErrorPage />,
          },
          {
            path: "mandatory-video-metadata",
            element: <MandatoryVideoMetadata />,
            errorElement: <ErrorPage />,
          },
          {
            path: "mandatory-document-metadata",
            element: <MandatoryDocumentMetadata />,
            errorElement: <ErrorPage />,
          },
          {
            path: "under-review",
            element: <UnderReviewPage />,
            errorElement: <ErrorPage />,
          },
          {
            path: "comments",
            element: <CommentsPage />,
            errorElement: <ErrorPage />,
          },
          {
            path: "*",
            element: <Navigate to="mandatory-metadata" replace />,
          },
        ],
      },
      {
        path: "/admin/:uploadId",
        element: <RequireAdmin />,
        errorElement: <ErrorPage />,
        children: [
          {
            index: true,
            element: <AdminPage />,
          },
          {
            path: "edit",
            element: <MetadataFlowPage />,
            children: [
              {
                index: true,
                element: <Navigate to="mandatory-metadata" replace />,
              },
              {
                path: "mandatory-metadata",
                element: <MandatoryMetadata />,
                errorElement: <ErrorPage />,
              },
              {
                path: "mandatory-metadata/:assetIds",
                element: <MandatoryMetadata />,
                errorElement: <ErrorPage />,
              },
              {
                path: "optional-metadata",
                element: <OptionalMetadata />,
                errorElement: <ErrorPage />,
              },
              {
                path: "optional-metadata/:assetIds",
                element: <OptionalMetadata />,
                errorElement: <ErrorPage />,
              },
            ],
            errorElement: <ErrorPage />,
          },
          {
            path: "edit/mandatory-document-metadata/:assetIds",
            element: <MandatoryDocumentMetadata />,
            errorElement: <ErrorPage />,
          },
          {
            path: "mandatory-video-metadata",
            element: <MandatoryVideoMetadata />,
            errorElement: <ErrorPage />,
          },
          {
            path: "*",
            element: <Navigate to="" replace />,
          },
        ],
      },
    ],
  },
]);

export default router;
